// import type { Action } from '../actions/types';
// import { UPDATE_CAM_ID, MATCH_CAM_ID } from '../actions/analytics';
import ActionTypes from '../actions/types';

// define node types
/* export type State = {
	fromCamId: number,
	toCamId: number,
}*/

// set initial states, self-explanatory const name.

const initialState = {
  event_id: 0,
  room_id: 0,
  venue_id: 0,
  organization_id: 0,
  event_code: 0,
  event_status: '',
  local_datetime: '',
  venue_datetime: '',
  unique_url: '',
  start: '',
  end: '',
  ip4: '',
  uuid: '',
  fromCamId: eventDataProps.data.main_camera_id ? eventDataProps.data.main_camera_id : 0, // analytic_data.data.camera_from, // camera_from
  toCamId: eventDataProps.data.main_camera_id ? eventDataProps.data.main_camera_id : 0, // analytic_data.data.camera_to, //camera_to
  browser: '',
  device: '',
};

export default function (state = initialState, action) {
  switch (action.type) {
    case ActionTypes.UPDATE_CAM_ID:
      console.log('update cam id reducer', state.toCamId, action.payload);
      return {
        ...state,
        fromCamId: parseInt(state.toCamId), // pass previous toCamId as fromCamId
        toCamId: parseInt(action.payload),
      };
    case ActionTypes.MATCH_CAM_ID:
      console.log('match cam id reducer', state.toCamId);
      return {
        ...state,
        fromCamId: parseInt(state.toCamId), // pass previous toCamId as fromCamId
        toCamId: parseInt(state.toCamId),
      };
    default:
      return state;
  }
}
